import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { UserRoundPen } from "lucide-react";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { Link } from "react-router-dom";
import StarRating from "../Star-Component/StarRating";

const CourseCard = ({
  name,
  course_icon,
  subject_count,
  offer_price,
  offer_discount,
  price,
  course_banner,
  lecture_count,
  note_count,
  dpp_count,
  test_count,
  rating,
  faculty_name,
  thumbnail,
  description,
  id,
  payment_plans
}) => {

  const plans = Array.isArray(payment_plans)
    ? payment_plans.filter(Boolean)
    : [];

  // const midPlan =
  //   plans.length > 0
  //     ? plans[(plans.length-1)]
  //     : null;

  // const paymentPlans = course.payment_plans || [];
  const plan12 = payment_plans.find(
    (plan) => Number(plan.validity) === 12
  );
  const maxPlan =
    payment_plans.length > 0
      ? payment_plans.reduce((max, plan) =>
        Number(plan.validity) > Number(max.validity) ? plan : max
      )
      : null;
  const midPlan = plan12 || maxPlan;

  return (
    <Link to={UNPROTECTED_ROUTES?.courseDetails + "/" + id + UNPROTECTED_ROUTES?.description}>
      <div className="rounded-2xl">
        <Card className="rounded-2xl">
          <CardContent
            style={{ fontFamily: "DM Sans" }}
            className="aspect-square p-0 shadow-2xl rounded-2xl"
          >
            {/* section 1 - course banner*/}
            <div className="lg:text-xl md:text-lg ml-5 my-2" style={{ fontWeight: "600" }}>
              {name}
            </div>
            <div className="relative w-full h-auto overflow-hidden rounded-xl">
              {course_banner ? (
                <img
                  src={course_banner}
                  alt={name || "Course"}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.parentElement
                      .querySelector(".course-card-placeholder")
                      ?.classList.remove("hidden");
                  }}
                />
              ) : null}

              <div
                className={`
      course-card-placeholder
      ${course_banner ? "hidden" : ""}
      absolute
      inset-0
      flex
      flex-col
      items-center
      justify-center
      rounded-xl
      bg-gradient-to-br
      from-[#F3EFF6]
      to-[#E7E1EB]
    `}
              >
                <div
                  className="
        flex
        h-12
        w-12
        items-center
        justify-center
        rounded-full
        bg-white
        shadow-sm
      "
                >
                  <span className="text-xl font-bold text-[#5A277C]">
                    R
                  </span>
                </div>

                <span className="mt-1 px-2 text-center text-sm font-semibold text-[#5A277C]">
                  {name || "Course"}
                </span>
              </div>
            </div>
            <div className="px-3">
              {/* Section 2 - faculty img + name & star*/}
              <div className="flex justify-between items-center my-2">
                {/* faculty img + name */}
                <div className="flex justify-between items-center">
                  <div>
                    {thumbnail ? (
                      <img
                        src={thumbnail}
                        alt={faculty_name}
                        className="w-10 h-10 rounded-full"
                        loading="lazy"
                      />
                    ) : (
                      <UserRoundPen />
                    )}
                  </div>
                  <div className="ml-2 lg:text-[1rem] text-xs">{faculty_name ? faculty_name : ""}</div>
                </div>
                {/* rating */}
                <div className="">
                  <StarRating rating={Math.floor(rating)} />
                </div>
              </div>
              {/* Section 3 - course name */}

              {/* Section 4 - Course Description */}
              <div className="md:text-sm text-xs my-3">
                {stripText(stripHtml(description), 80)}
              </div>
              {/* Section 5 - Metrics */}
              <div className="flex justify-around border-b border-gray-200 pb-2 lg:text-[1rem] text-sm">
                {/* Lecture */}
                <div className="flex flex-col items-center">
                  <div className="font-semibold">{lecture_count}+</div>
                  <div className="text-[#82808D]">Lectures</div>
                </div>
                {/* Hand Notes */}
                <div className="flex flex-col items-center">
                  <div className="font-semibold">{note_count}+</div>
                  <div className="text-[#82808D]">Hand Notes</div>
                </div>
                {/* DPP */}
                <div className="flex flex-col items-center">
                  <div className="font-semibold">{dpp_count}+</div>
                  <div className="text-[#82808D]">DPP</div>
                </div>
                {/* Live tests */}
                <div className="flex flex-col items-center">
                  <div className="font-semibold">{test_count}+</div>
                  <div className="text-[#82808D]">Live Tests</div>
                </div>
              </div>
              {/* Section 6 - Button and Price */}
              <div className="flex justify-between items-center my-[1rem] lg:text-[1rem] text-sm">
                {/* Price */}
                {midPlan && (
                  <div className="flex flex-col items-center">
                    {Number(midPlan?.offer_discount || 0) > 0 && (
                      <div className="line-through text-gray-500 text-xs">
                        ₹{midPlan?.price}
                      </div>
                    )}

                    <div className="px-4 py-2 rounded-2xl bg-[#5A277C] text-white">
                      ₹
                      {Number(midPlan?.offer_discount || 0) > 0
                        ? midPlan?.offer_price
                        : midPlan?.price}
                    </div>

                    <div className="mt-1 text-xs font-semibold text-gray-500">
                      for {midPlan?.validity || 0} Months
                    </div>
                  </div>
                )}
                {/* buttons */}
                <div className="flex gap-3">
                  {/* Explore More Button */}

                  <div>
                    <Link to={UNPROTECTED_ROUTES?.courseDetails + "/" + id + UNPROTECTED_ROUTES?.description}>
                      <button
                        className="text-[#03B3C3] px-2 py-1 rounded-xl cursor-pointer"
                        style={{
                          backgroundColor: "rgba(30, 203, 219, 0.15)",
                          fontWeight: 700,
                        }}
                      >
                        Explore More
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="text-white text-[1px]">h</div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Link>
  );
};

export default CourseCard;
